import { render, staticRenderFns } from "./MyNeofintechProducts.vue?vue&type=template&id=1ed79fec&scoped=true&"
import script from "./MyNeofintechProducts.vue?vue&type=script&lang=js&"
export * from "./MyNeofintechProducts.vue?vue&type=script&lang=js&"
import style0 from "./MyNeofintechProducts.vue?vue&type=style&index=0&id=1ed79fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed79fec",
  null
  
)

export default component.exports